import React from "react";
import UseContext from "../../hooks/useContext";
import useModal from "../modal/useModal";
import { SettingRow } from "../settings/SettingRow";
import { formatCompanySettingLastModified } from "../../utils/formatCompanySettingLastModified";

function PdnsBlock({ isPdns, lastModified, isWaiting, onCommitPdns }) {
  const { setModalData } = UseContext();
  const { toggle } = useModal();

  const openModal = () => {
    setModalData({
      block: "pdns",
      isPdns,
      isWaiting,
      commitPdns: onCommitPdns,
      modalSessionKey: Date.now(),
    });
    toggle("settings_edit_block");
  };

  const description = isWaiting ? (
    <div className="h-4 max-w-lg animate-pulse rounded bg-gray-200" />
  ) : (
    <>
      Une ligne PDNS sera ajoutée avec la valeur{" "}
      <strong className="font-semibold text-gray-800">1.0</strong> pour chaque
      jour travaillé.
    </>
  );

  return (
    <SettingRow
      title="Ajout du code PDNS dans le fichier Peopulse"
      description={description}
      footnote={
        !isWaiting ? formatCompanySettingLastModified(lastModified) : undefined
      }
      onEdit={openModal}
    />
  );
}

export default PdnsBlock;
